import KakaoMapDrawing from '../components/KakaoMapDrawing';

const MapToolsPage: React.FC = () => {
  const handleShapeDrawn = (shapeData: unknown) => {
    console.log('Shape drawn:', shapeData);
  };

  const handleMapReady = (map: unknown, drawingManager: unknown) => {
    console.log('Map and drawing manager ready:', map, drawingManager);
  };

  return (
    <div className="page-full">
      <div className="card">
        <div className="card-body">
          <h1 className="page-title mb-1">지도 도구</h1>
          <p className="page-subtitle mb-4">
            도형 도구로 건물 경계를 그리고 편집합니다.
          </p>
        </div>

        <div className="px-4 pb-4">
          <div className="bg-brand-50 rounded-xl p-4 mb-4">
            <h3 className="text-sm font-semibold text-brand-700 mb-2">사용 안내</h3>
            <ul className="text-xs text-brand-600 space-y-1">
              <li>• 도구 모음에서 그리기 도구를 선택하세요</li>
              <li>• 다각형: 여러 점을 클릭 후 더블클릭으로 완성</li>
              <li>• 사각형: 클릭 후 드래그하여 생성</li>
              <li>• Copy JSON으로 좌표 데이터를 복사할 수 있습니다</li>
            </ul>
          </div>

          <KakaoMapDrawing
            height="500px"
            center={{ lat: 37.5665, lng: 126.978 }}
            level={3}
            onShapeDrawn={handleShapeDrawn}
            onMapReady={handleMapReady}
          />
        </div>
      </div>
    </div>
  );
};

export default MapToolsPage;
